import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { IRootState } from '../types/store';
import { CHANGE_PASSWORD_ROUTE, lOGIN_ROUTE } from '../constants/routes';

const ProtectedRoute: React.FC = () => {
  const { isLoggedIn, passwordExpired } = useSelector((state: IRootState) => state.user);
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to={lOGIN_ROUTE} replace />;
  }

  // Redirect users to /change-password if their password is expired
  if (passwordExpired && location.pathname !== CHANGE_PASSWORD_ROUTE) {
    return <Navigate to={CHANGE_PASSWORD_ROUTE} replace />;
  }

  // Render nested routes inside drawer
  return <Outlet />;
};

export default ProtectedRoute;
